var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SVGIconRoot } from './style';
import { useTheme } from '../../styling/useTheme';
export var SVGIcon = function SVGIcon(_a) {
  var children = _a.children,
      title = _a.title,
      viewBox = _a.viewBox,
      width = _a.width,
      height = _a.height,
      color = _a.color,
      restProps = __rest(_a, ["children", "title", "viewBox", "width", "height", "color"]);

  var fillColor = color || 'currentColor';
  var theme = useTheme();
  return React.createElement(SVGIconRoot, Object.assign({
    viewBox: viewBox,
    focusable: "false",
    color: fillColor,
    iconWidth: width,
    iconHeight: height,
    theme: theme.armor
  }, restProps), !!title && React.createElement("title", null, title), children);
};
export var SVGIconGroup = function SVGIconGroup(_ref) {
  var children = _ref.children;
  return React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, children);
};
export var SVGIconPath = function SVGIconPath(_ref2) {
  var d = _ref2.d,
      transform = _ref2.transform;
  return React.createElement("path", {
    d: d,
    transform: transform,
    fill: "currentColor"
  });
};
SVGIcon.defaultProps = {
  display: 'inline-block',
  height: '1em',
  width: '1em',
  viewBox: '0 0 24 24'
};